import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from "@angular/core";
import { ControlContainer, FormGroupDirective } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ConfirmationDialogComponent } from "@dialogs/confirmation/confirmation.component";
import { DownloadDialogComponent } from "@dialogs/download/download.component";
import { ExoandDialogComponent } from "@dialogs/expand/expand.component";
import {
  faDownload,
  faTrash,
  faUpRightAndDownLeftFromCenter,
} from "@fortawesome/pro-solid-svg-icons";
import { DownloadService } from "@services/download.service";
import { CanvasService } from "@services/canvas.service";

import {
  GridsterConfig,
  GridsterItem,
  GridsterItemComponent,
} from "angular-gridster2";
import { CHARTS } from "../../../models/charts";
import { CanvasSearchDialogComponent } from "@dialogs/canvas-search/canvas-search.component";
import { environment } from "@environments/environment";
import {
  faGripVertical,
  faTriangleExclamation,
} from "@fortawesome/pro-solid-svg-icons";
@Component({
    selector: "app-canvas-items",
    templateUrl: "./canvas-items.component.html",
    styleUrls: ["./canvas-items.component.scss"],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
    standalone: false
})
export class CanvasItemsComponent
  implements OnInit, OnChanges, AfterViewChecked
{
  @Output() addChartChange = new EventEmitter<any>();
  @Input() chartData: any;
  @Input() preview?: boolean;
  @Input() hasEdit?: boolean = true;
  @Input() isDirty!: boolean;
  @Input() loading!: boolean;
  @Input() selectedItem!: any;
  @Input() canvasType!: any;
  @Input() canvasMode!: any;
  @Input() canvasLayout!: any;
  @Input() customLinks?: any;
  @Input() page!: any;
  @Input() viewable?: any = false;

  @Output() selectChartChange = new EventEmitter<any>();
  @Output() chartTextChange = new EventEmitter<any>();

  constructor(
    public downloadService: DownloadService,
    public parentForm: FormGroupDirective,
    private _snackBar: MatSnackBar,
    private canvasService: CanvasService,
    public dialog: MatDialog,
    private cdRef: ChangeDetectorRef
  ) {}

  childForm: any;
  public parameterValue: string = "";
  public style: object = {};
  public styleArray: any[] = [];
  public reportTitle!: string;
  public reportHasHeader: boolean = false;
  public reportHasFooter: boolean = false;

  public component = this;

  faTrash = faTrash;
  faDownload = faDownload;
  faUpRightAndDownLeftFromCenter = faUpRightAndDownLeftFromCenter;
  faGripVertical = faGripVertical;
  faTriangleExclamation = faTriangleExclamation;
  itemId: any;

  options!: GridsterConfig;
  dashboard!: GridsterItem[];
  itemToPush!: GridsterItemComponent;
  sorted: any = [];
  editOptions: GridsterConfig = {
    itemChangeCallback: this.itemChange.bind(this),
    itemResizeCallback: this.itemResize.bind(this),
    gridType: "fit",
    compactType: "compactUp",
    resizable: {
      enabled: true,
    },
    draggable: {
      delayStart: 0,
      enabled: true,
      ignoreContent: false,

      stop: this.itemDragEnd.bind(this),
      // start: CanvasItemsComponent.eventStart,
      dropOverItems: true,
      //dropOverItemsCallback: CanvasItemsComponent.overlapEvent,
    },
    pushItems: true,
    displayGrid: "always",
    disableScrollHorizontal: true,
    minCols: 4,
    maxCols: 4,
    minRows: 4,
    defaultItemCols: 4,
    defaultItemRows: 1,
    maxItemRows: 4,
    swap: true,
    swapWhileDragging: true,
    outerMargin: true,
    outerMarginTop: 10,
    outerMarginRight: 15,
    outerMarginBottom: 10,
    outerMarginLeft: 15,
  };

  viewOptions: GridsterConfig = {
    //  itemChangeCallback: CanvasItemsComponent.itemChange,
    //itemResizeCallback: CanvasItemsComponent.itemResize,
    gridType: "scrollVertical",
    resizable: {
      enabled: false,
    },
    draggable: {
      enabled: false,
    },
    pushItems: true,
    displayGrid: "none",
    disableScrollHorizontal: true,
    minCols: 4,
    maxCols: 4,
    minRows: 1,
    defaultItemCols: 4,
    defaultItemRows: 1,
    outerMargin: true,
    outerMarginTop: 10,
    outerMarginRight: 15,
    outerMarginBottom: 10,
    outerMarginLeft: 15,
  };
  public itemChange(item: any, itemComponent: any) {
    this.sorted = this.dashboard.sort(this.sortFunc);
  }

  public itemResize(item: any, itemComponent: any) {
    // console.info("itemResized", item, itemComponent);
  }
  sortFunc(a: any, b: any) {
    if (a.y < b.y) {
      return -1;
    }
    if (a.y > b.y) {
      return 1;
    }
    return 0;
  }

  public itemDragEnd(item: any, itemComponent: any, event: any) {
    this.sorted = this.dashboard.sort(this.sortFunc);
  }

  changedOptions() {
    // this.options.api.optionsChanged();
  }

  removeItem(item: any) {
    this.dashboard.splice(this.dashboard.indexOf(item), 1);
  }

  addItem() {
    // this.dashboard.push({});
  }

  itemWidth(chart: any) {
    if (this.canvasMode == "edit") return {};
    if (this.canvasType == "report") return {};
    if (typeof this.canvasMode == "undefined") return {};
    let width = chart.cols * 50 + "%";
    let height = chart.row * 150 + "px";
    return {
      width: width,
      height: height,
      display: "inline-block",
      "vertical-align": "top",
    };
  }
  getIcon(chartObj: any) {
    const chart: any = CHARTS.filter((item: any) => {
      return item.type.details == chartObj.object.data.chartType;
    });
    if (chart[0]) {
      return chart[0].icon;
    }
  }

  chartTextChangedHandler(event: any) {
    this.chartTextChange.emit(event);
  }

  openExpandDialog(chart: any, event: any): void {
    event.stopPropagation();

    var element = document.querySelector(".main-container");

    const dialogRef = this.dialog.open(ExoandDialogComponent, {
      maxWidth: "100vw",
      maxHeight: "100vh",
      height: "100%",
      width: "100%",
      data: {
        chart: chart,
        form: this.childForm,
      },
      panelClass: "canvas-dialog",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
    });
  }
  openChartDownloadDialog(
    title: string,
    chartID: any,
    chart: any,
    event: any
  ): void {
    event.stopPropagation();
    const id = this.childForm.get("id")!.value;
    let type = "";
    if (chart.canvasItemType == "chart") {
      type = chart.object.data.chartType;
    } else {
      type = chart.object.data.type;
    }
    let showMessage = false;
    let dirtyHolder = false;

    if (this.isDirty) {
      showMessage = true;
      dirtyHolder = true;
    }
    const dialogRef = this.dialog.open(DownloadDialogComponent, {
      width: "350px",
      data: {
        id: id,
        title: title.split(" ").join("_").replace("'", ""),
        type: type,
        fullReport: false,
        showMessage: showMessage,
      },
      panelClass: "canvas-dialog",
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.isDirty = dirtyHolder;
      if (result && result.result) {
        if (result.save) {
          const exportBody = {
            id: this.parameterValue,
            title: result.title,
            type: result.type,
            chartID: chartID,
            action: "export",
          };

          this.canvasService.triggerSaveAndExport(exportBody);
        } else {
          this.downloadService.startExport(
            this.parameterValue,
            this.canvasType,
            result.title,
            result.type,
            chartID
          );
        }
      }
    });
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, "", {
      duration: 3000,
      panelClass: ["canvas-snackbar"],
    });
  }

  selectChart(id: number, chart: any) {
    const data = { id: id, chart: chart };
    this.selectChartChange.emit(data);
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer.id == "list-2") {
      if (event.item.data.type == "chart") {
        if (event.item.data.details == "existing") {
          const dialogRef = this.dialog.open(CanvasSearchDialogComponent, {
            disableClose: true,
            data: { canvasType: this.canvasType },
            panelClass: ["canvas-dialog"],
            width: "75vw",
          });

          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.canvasService.getCanvasItem(result).subscribe(
                (success: any) => {
                  const canvasItem = success.data;
                  canvasItem.id = null;
                  const obj = { data: canvasItem };
                  const chart = {
                    canvasItemType: "chart",
                    isVisible: true,
                    id: canvasItem.id,
                    object: obj,
                  };

                  this.chartData.push(chart);
                  this.styleArray.push({});
                  this.canvasService.saveCanvasItems(this.chartData);
                  this.checkForHeaderAndFooter();
                  this.moveChartToPosition(event);
                  this.selectChartAfterCreation(event);
                },
                (error: any) => {}
              );
            }
          });
        } else {
          //this.canvasService.triggerDisable();
          this.canvasService
            .createChart(
              this.childForm.get("id")!.value,
              event.item.data.details
            )
            .subscribe((success: any) => {
              //this.canvasService.triggerEnable();
              const successDataObject: any = {
                canvasItemType: "chart",
                isVisible: true,
                object: {
                  data: success.data,
                },
                id: null,
              };
              this.chartData.push(successDataObject);
              this.styleArray.push({});
              this.canvasService.saveCanvasItems(this.chartData);
              this.checkForHeaderAndFooter();
              this.moveChartToPosition(event);
              this.selectChartAfterCreation(event);
            });
        }
      } else {
        if (event.item.data.details == "header" && this.reportHasHeader) {
          return;
        }
        if (event.item.data.details == "footer" && this.reportHasFooter) {
          return;
        }
        const success: any = {
          data: {
            canvasItemType: event.item.data.details,
            object: {
              data: {
                chartObject: [],
                type: event.item.data.details,
              },
            },
            id: null,
          },
        };

        this.chartData.push(success.data);

        this.styleArray.push({});
        //this.checkForHeaderAndFooter();
        this.moveChartToPosition(event);
      }
    } else {
      this.moveChartToPosition(event);
    }
  }

  copyGridCoordinatesInReportMode(previousIndex: number, currentIndex: number) {
    //copy previous index to current index
    let yTemp = this.chartData[currentIndex].y;
    let xTemp = this.chartData[currentIndex].x;

    this.chartData[currentIndex].y = this.chartData[previousIndex].y;
    this.chartData[currentIndex].x = this.chartData[previousIndex].x;

    this.chartData[previousIndex].y = yTemp;
    this.chartData[previousIndex].x = xTemp;
  }
  moveChartToPosition(event: any) {
    this.canvasService.triggerDirty();
    if (this.reportHasHeader && event.currentIndex == 0) {
      event.currentIndex = 1;
    }
    if (
      this.reportHasFooter &&
      event.currentIndex == this.chartData.length - 1
    ) {
      event.currentIndex = this.chartData.length - 2;
    }

    if (event.item.data) {
      if (event.item.data.details == "header") {
        event.currentIndex = 0;
      }
      if (event.item.data.details == "footer") {
        event.currentIndex = this.chartData.length;
      }
    }
    if (event.previousContainer.id == "list-2") {
      moveItemInArray(
        this.chartData,
        this.chartData.length,
        event.currentIndex
      );

      moveItemInArray(
        this.styleArray,
        this.chartData.length,
        event.currentIndex
      );
      this.canvasService.saveCanvasItems(this.chartData);
    } else {
      if (event.previousIndex != event.currentIndex) {
        this.copyGridCoordinatesInReportMode(
          event.previousIndex,
          event.currentIndex
        );
        moveItemInArray(
          this.chartData,
          event.previousIndex,
          event.currentIndex
        );

        moveItemInArray(
          this.styleArray,
          event.previousIndex,
          event.currentIndex
        );
        this.canvasService.saveCanvasItems(this.chartData);
      }
    }
  }
  selectChartAfterCreation(event: any) {
    if (this.chartData.length == 1) {
      this.selectChart(0, this.chartData[0]);
    } else {
      this.selectChart(event.currentIndex, this.chartData[event.currentIndex]);
    }
  }
  removeChart(event: any, index: number, type: string): void {
    event.stopPropagation();
    let message = "Remove this chart?";
    if (type != "chart") message = "Remove this widget?";
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: {
        message: message,
        actionButton: "remove",
      },
      panelClass: "canvas-dialog",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.chartData.splice(index, 1);
        this.canvasService.saveCanvasItems(this.chartData);
        this.selectChart(0, this.chartData[0]);
        this.checkForHeaderAndFooter();
      }
    });
  }
  checkForHeaderAndFooter() {
    const headerExists = this.chartData.filter(function (element: any) {
      return element.canvasItemType == "header";
    });
    if (headerExists.length > 0) {
      this.reportHasHeader = true;
    } else {
      this.reportHasHeader = false;
    }
    const footerExists = this.chartData.filter(function (element: any) {
      return element.canvasItemType == "footer";
    });
    if (footerExists.length > 0) {
      this.reportHasFooter = true;
    } else {
      this.reportHasFooter = false;
    }
  }
  showGridster() {
    let show = false;

    if (
      (this.canvasMode == "edit" && this.canvasLayout) ||
      (this.canvasMode == "view" && !this.canvasLayout)
    )
      show = true;
    if (this.canvasType == "report") show = false;
    return show;
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  ngOnChanges() {
    if (this.childForm) {
      this.reportTitle = this.childForm.controls["title"].value;
    }
    this.dashboard = this.chartData;

    if (this.canvasMode == "edit") {
      this.options = this.editOptions;
    } else {
      this.options = this.viewOptions;
    }

    // this.chartData.forEach((element: any) => {
    //   console.log(element);
    //   if (
    //     element.canvasItemType == "chart" &&
    //     element.object.data.chartType == "Table"
    //   ) {
    //     element.isVisible = false;
    //   }
    // });
  }
  ngOnInit(): void {
    this.childForm = this.parentForm.form;
    if (this.childForm) {
      this.reportTitle = this.childForm.controls["title"].value;
    }

    if (this.canvasMode == "edit") {
      this.options = this.viewOptions;
    } else {
      this.options = this.viewOptions;
    }
  }
}
